/**
 * Registry of available icons for custom mobility service buttons.
 *
 * Keys must stay in sync with the admin app's mobility-icon-registry.jsx.
 * Each key is stored in MobilityService.icon in the database.
 */
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import GetAppIcon from '@mui/icons-material/GetApp';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import PaymentIcon from '@mui/icons-material/Payment';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';

/** Default icon component used when a custom button has no icon key set. */
export const DEFAULT_CUSTOM_ICON = OpenInNewOutlinedIcon;

/** Lookup map: icon key (string stored in DB) → MUI icon component. */
export const MOBILITY_ICON_REGISTRY = {
  OpenInNew:    OpenInNewOutlinedIcon,
  ShoppingCart: ShoppingCartOutlinedIcon,
  Phone:        PhoneOutlinedIcon,
  Videocam:     VideocamOutlinedIcon,
  Mic:          MicNoneOutlinedIcon,
  SmartToy:     SmartToyOutlinedIcon,
  Info:         InfoOutlinedIcon,
  Help:         HelpOutlineIcon,
  Notif:        NotificationsNoneIcon,
  Star:         StarBorderIcon,
  Language:     LanguageIcon,
  Bus:          DirectionsBusIcon,
  Map:          MapIcon,
  Location:     LocationOnIcon,
  Calendar:     CalendarTodayIcon,
  Download:     GetAppIcon,
  Payment:      PaymentIcon,
  Search:       SearchIcon,
  ReportProblem: ReportProblemOutlinedIcon,
  ThumbUp:      ThumbUpAltOutlinedIcon,
};

/** Keys allowed by the API — keep in sync with mobility_icons.py */
export const ALLOWED_MOBILITY_ICON_KEYS = Object.keys(MOBILITY_ICON_REGISTRY);
